import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH = 'M32 0L64 22.918L51.7771 60H12.2229L0 22.918L32 0Z'
const RAW_WIDTH = 64
const RAW_HEIGHT = 60

/**
 * Pentagon shape component
 * @type {import('./CustomPath').CustomPath}
 */
export const PentagonShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default PentagonShape
